export const ReportConfigData = `
  reportId
  embedUrl
  embedToken
`;
